<div class="edit_stepper__{{retourAuthorized ? 'window' : 'tab'}}">
<mat-drawer-container autosize>
  <ng-container *ngIf="dossier?.id && (showComments() | async) && !ctsread.opened">
    <button class="sitcky-btn" mat-raised-button color="primary" (click)="ctsread.toggle()">
      <mat-icon>message</mat-icon>
    </button>
  </ng-container>
  <mat-drawer class="comments" #ctsread position="end" mode="side">
    <ng-container *ngIf="dossier?.id > 0">
      <app-comments [ngStyle]="{'width': '350px', 'display':'block'}"
                    (changer)="ctsread.toggle()"
                    [opened]="ctsread.opened"
                    [commentator]="individuConnected"
                    [roles]="rolesConnecte"
                    [dossier]="dossier">
      </app-comments>
    </ng-container>
  </mat-drawer>


  <p8-layout-settings-page>
    <p8-layout-settings-header
      [titlePath]="['Dossier', getTitle()]">
    </p8-layout-settings-header>
    <!-- demandeur / contacts -->
    <mat-card *ngIf="isUpdateMode">
      <app-demandeur-dar [dossier]="dossier"
                         [rolesConnecte]="rolesConnecte"
                         (onDemandeurUpdated)="onDemandeurUpdated()"></app-demandeur-dar>
      <app-contacts-dar [dossier]="dossier"
                        [rolesConnecte]="rolesConnecte"
                        [individuConnected]="individuConnected"></app-contacts-dar>
    </mat-card>
    <!-- dossier DAR -->
    <mat-card>
      <!-- entête dossier -->
      <mat-card-subtitle>
        <div fxLayout="column">
          <app-state-chip [dossier]="dossier"></app-state-chip>

          <div fxLayoutAlign="begin center">
            <span *ngIf="dossier?.type_demande" style="font-size: 1.2em;">{{ dossierSvc.getLabelTypeDemande(dossier.type_demande) }}</span>
          </div>

          <div fxLayoutAlign="end center">
            <span *ngIf="dossier?.individu" style="font-size: 1.2em;">{{dossier?.individu?.first_name}} {{dossier?.individu?.last_name}}</span>
          </div>

          <div fxLayoutAlign="end center"  *ngIf="affectationFormGroup.get('dir_cmp_label').value">
            <span>{{ affectationFormGroup.get('dir_cmp_label').value }}</span>
          </div>

          <div fxLayoutAlign="end center">
            <span *ngIf="dossier?.reference" style="font-size: 1.2em;">{{dossier?.reference}}</span>
          </div>

          <div fxLayoutAlign="end center">
            <span *ngIf="dossier?.decision_commission" style="font-size: 1.2em;">{{getDecision(dossier?.decision_commission)}}</span>
          </div>
        </div>
      </mat-card-subtitle>

      <mat-card-content>
        <!-- Calculette cout en commission -->

        <div style="padding-bottom: 10px;" *ngIf="(isInCommission() && (hasRoleGestion$ | async))">
          <mat-expansion-panel *ngIf="dossier?.cout_estime" [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Calculatrice commission
              </mat-panel-title>
              <mat-panel-description >
                Ajustement coût sur indiciaire ou horaire
              </mat-panel-description>
            </mat-expansion-panel-header>

            <app-periode-commission
              *ngIf="dossier"
              [dossier]="dossier"
              (periodeUpdated)="onCalculateCommission($event)"></app-periode-commission>
          </mat-expansion-panel>
          <mat-expansion-panel *ngIf="! dossier?.cout_estime">
            <mat-expansion-panel-header>
              <mat-panel-title>
                Calculatrice commission
              </mat-panel-title>
              <mat-panel-description >
                Ajustement coût sur indiciaire ou horaire
              </mat-panel-description>
            </mat-expansion-panel-header>
            <span>Aucun coût estimé trouvé, la calculatrice ne peut fonctionner</span>
          </mat-expansion-panel>
        </div>

        <!-- Gestion du dossier -->

        <mat-expansion-panel style="padding-top: 10px;" [expanded]="true"
                             *ngIf="dossier?.state !== stateEnum.demande && dossier?.id > 0 && (hasRoleGestion$ | async)">

          <mat-expansion-panel-header>
            <mat-panel-title>
              Gestion du dossier
            </mat-panel-title>
            <mat-panel-description >
              Masse salariale / SBTCP / RH / Observations commission
            </mat-panel-description>
          </mat-expansion-panel-header>
          <div>
            <app-form-ms-sbtcp
              (emploiUpdated)="emploiUpdated($event)"
              [dossier]="dossier"
              [canEditEmploi]="(((hasRole(rolesDarEnum.drh) | async) || (hasRole(rolesDarEnum.masse_salariale) | async) ||
                               (hasRole(rolesDarEnum.sbtcp) | async) || (hasRole(rolesDarEnum.recrutement)| async) ||
                               (hasRole(rolesDarEnum.recrutement_spte) | async)) && (canEditEmploi(dossier.state) | async))
                               || ((hasRole(rolesDarEnum.drh) | async) || (hasRole(rolesDarEnum.gestionnaire) | async))"
              [isInRole]="(hasRole(rolesDarEnum.masse_salariale) | async) || (hasRole(rolesDarEnum.sbtcp) | async)"></app-form-ms-sbtcp>


            <app-avis-ms *ngIf="dossier?.id > 0"
                         [isInRole]="hasRole(rolesDarEnum.masse_salariale) | async"
                         (avisUpdated)="avisUpdated($event)"
                         (commentaireUpdated)="commentaireUpdated($event)"
                         [avis]="dossier?.avis_ms"
                         [commentaire]="dossier?.commentaire_avis_ms"></app-avis-ms>
            <app-observations-historique
              [title]="'Historique des commentaires MS'"
              [observations_historique]="dossier.observation_historique?.[observationsHistoriqueEnum.commentaire_ms]"></app-observations-historique>
            <app-avis-sbtcp *ngIf="dossier?.id > 0"
                            [isInRole]="hasRole(rolesDarEnum.sbtcp) | async"
                            (avisUpdated)="avisUpdated($event)"
                            (commentaireUpdated)="commentaireUpdated($event)"
                            (winpayeUpdated)="winpayeUpdated($event)"
                            [avis]="dossier?.avis_sbtcp"
                            [commentaire]="dossier?.commentaire_avis_sbtcp"
                            [winpaye]="dossier?.winpaye_sbtcp_obj"></app-avis-sbtcp>
            <app-observations-historique
              [title]="'Historique des commentaires SBTCP'"
              [observations_historique]="dossier.observation_historique?.[observationsHistoriqueEnum.commentaire_sbtcp]"></app-observations-historique>
            <app-avis-drh *ngIf="dossier?.id > 0 && ((hasRole(rolesDarEnum.drh) | async) ||
                                                      (hasRole(rolesDarEnum.commission) | async))"
                          [isInRole]="hasRole(rolesDarEnum.drh) | async"
                          (avisUpdated)="avisUpdated($event)"
                          (commentaireUpdated)="commentaireUpdated($event)"
                          [avis]="dossier?.avis_drh"
                          [commentaire]="dossier?.commentaire_avis_drh"></app-avis-drh>
            <app-observations-historique
              [title]="'Historique des commentaires DRH'"
              [observations_historique]="dossier.observation_historique?.[observationsHistoriqueEnum.commentaire_drh]"></app-observations-historique>
            <app-obs-commission *ngIf="dossier?.id > 0 && (hasRole(rolesDarEnum.commission) | async)"
                                [isInRole]="(hasRole(rolesDarEnum.commission) | async)"
                                [isInState]="(dossier?.state === stateEnum.commission || dossier?.state === stateEnum.commission_decision)"
                                [observations]="dossier?.observations_commission"
                                (observationsUpdated)="observationsUpdate($event)">
            </app-obs-commission>
            <app-observations-historique
              [title]="'Historique des observations de la commission'"
              [observations_historique]="dossier.observation_historique?.[observationsHistoriqueEnum.observations_commission]"></app-observations-historique>
          </div>
        </mat-expansion-panel>

        <!-- Formulaire -->

        <!-- TODO => splitter en components ? -->

        <div fxLayoutGap="15px" style="padding-top: 20px;">
          <p>Ce formulaire vous permet de remplir une <strong>demande d'autorisation de recrutement</strong> en ligne.</p>
          <p><span class="mandatory-field">Les champs marqués par un <strong class="mandatory-field">*</strong> sont obligatoires</span> pour pouvoir envoyer votre demande auprès de la Dipefas, le bouton "Enregistrer et envoyer ma demande" restera <strong>grisé</strong> tant que tous les champs ne seront pas remplis.</p>
          <p>En revanche, vous pouvez à tout moment <strong>sauvegarder</strong> en mode brouillon votre demande en cours de saisie pour y revenir plus tard.</p>

          <mat-vertical-stepper  #stepper
                                 [linear]="false"
                                 (selectionChange)="onStepChanged($event)">

            <!-- Population de recrutement -->

            <mat-step [stepControl]="typeRecrutFormGroup">
              <form [formGroup]="typeRecrutFormGroup">
                <ng-template matStepLabel>Population de recrutement</ng-template>
                <p style="padding-bottom: 20px;">Veuillez choisir la cible du recrutement que vous souhaitez</p>
                <div>
                  <mat-radio-group formControlName="type_demande"
                                   (change)="onChangeTypeDemande($event)"
                                   [disabled]="isAlreadyPopulationChecked()">
                    <mat-radio-button *ngFor="let typedemande of typesDemandes"
                                      [value]="typedemande.id"> {{typedemande.label}}&nbsp;</mat-radio-button>
                  </mat-radio-group>

                  <div fxLayoutAlign="end center">
                    <button mat-stroked-button color="accent" (click)="nextPoste()" [disabled]="!typeRecrutFormGroup?.valid">Suivant</button>
                  </div>
                </div>

              </form>
            </mat-step>

            <!-- Poste -->

            <mat-step [stepControl]="posteFormGroup" *ngIf="hasTypeDemande()">
              <form [formGroup]="posteFormGroup">
                <ng-template matStepLabel><span class="mandatory-field">*</span> Poste</ng-template>
                <div>
                  <span class="mandatory-field">*&nbsp;</span>
                  <mat-form-field fxFlex="50" fxFlex.lt-md="90">
                    <mat-select formControlName="motivation"
                                placeholder="Motivation de la demande">
                      <mat-option *ngFor="let motivation of motivations" [value]="motivation.id">
                        {{motivation.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div>
                  <mat-form-field fxFlex="50" fxFlex.lt-md="90">
                    <mat-label>Motif / description de la demande</mat-label>
                    <textarea type="text" matInput formControlName="motif" rows="3"></textarea>
                  </mat-form-field>
                </div>

                <div>
                  <div  fxLayout="column">
                    <div style="padding-bottom: 10px;">
                      <mat-expansion-panel [expanded]="expandLdap">
                        <mat-expansion-panel-header>
                          <mat-panel-title>Le cas échéant, dernier occupant sur le poste, aide à la saisie</mat-panel-title>
                        </mat-expansion-panel-header>
                        <app-search-ldap fxFlex="70" [ldapDisplayProperty]="'cn,mail'"
                                         [removeDiatrics]="true"
                                         [titleLabel]="'Le cas échéant, dernier occupant sur le poste'"
                                         [placeHolder]="'Rechercher une personne dans l\'annuaire puis la sélectionner pour l\'ajouter...'"
                                         [scope]="true"
                                         [title]="false"
                                         [defaultScopes]="'employee'"
                                         [scopesToDisplay]="['employee', 'faculty', 'researcher']"
                                         (ldapUserSelected)="onSelectLastOccupant($event)">
                        </app-search-ldap>
                      </mat-expansion-panel>
                    </div>

                    <div fxLayout="row" fxLayoutGap="5px">
                      <mat-form-field fxFlex="30">
                        <input formControlName="last_occupant_first_name"
                               matInput [UpperCaseFirstLetter]="true"
                               maxlength="80"
                               placeholder="Prénom du dernier occupant">
                        <mat-hint align="end"><code>{{posteFormGroup.get('last_occupant_first_name').value?.length}}</code> / <code>80</code></mat-hint>
                      </mat-form-field>

                      <mat-form-field fxFlex="30">
                        <input formControlName="last_occupant_last_name"
                               matInput [UpperCaseFirstLetter]="true"
                               maxlength="80"
                               placeholder="Nom du dernier occupant">
                        <mat-hint align="end"><code>{{posteFormGroup.get('last_occupant_last_name').value?.length}}</code> / <code>80</code></mat-hint>
                      </mat-form-field>
                    </div>
                  </div>
                </div>

                <div>
                  <span class="mandatory-field">*&nbsp;</span>
                  <mat-form-field fxFlex="50" fxFlex.lt-md="60"
                                  fxLayoutGap="10" style="padding-right: 10px;" >
                    <mat-select  formControlName="intitule_poste"
                                 placeholder="Intitulé du poste">
                      <mat-option *ngFor="let intitule of intitules" [value]="intitule.id">
                        {{intitule.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>

                  <mat-form-field fxFlex="40" fxLayoutGap="10" >
                    <input formControlName="intitule_poste_autre"
                           matInput
                           [UpperCaseFirstLetter]="true"
                           maxlength="250"
                           placeholder="Intitulé si non trouvé">
                    <mat-hint align="end"><code>{{posteFormGroup.get('intitule_poste_autre').value?.length}}</code> / <code>250</code></mat-hint>
                  </mat-form-field>
                </div>
                <span class="mandatory-field">*&nbsp;</span>
                <mat-form-field>
                  <mat-select formControlName="categorie_equivalence"
                              placeholder="Catégorie ou équivalence">
                    <mat-option *ngFor="let categorie of categories" [value]="categorie.id">
                      {{categorie.label}}
                    </mat-option>
                  </mat-select>
                </mat-form-field>

                <div fxLayoutAlign="end center">
                  <button mat-stroked-button color="accent" (click)="nextImputation()" [disabled]="!posteFormGroup?.valid">Suivant</button>
                </div>
              </form>
            </mat-step>

            <!-- Imputations budgétaires : Convention / Opération, LOLF, code analytique -->

            <mat-step [stepControl]="imputationBudgetFormGroup" *ngIf="hasTypeDemande()">
              <form [formGroup]="imputationBudgetFormGroup">
                <ng-template matStepLabel>Imputation budgétaire</ng-template>

                <!-- Convention / opération -->

                <div [hidden]="convention_obj_temp">
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>Convention / Opération sur l'année {{currentYear}}</mat-panel-title>
                    </mat-expansion-panel-header>

                    <mat-checkbox (change)="switchYearLastYear($event.checked)">
                     Recherche sur l'année {{ currentYear - 1 }}
                    </mat-checkbox>

                    <div class="convention_recherche">
                      <div>
                        <mat-form-field fxFlex="50" appearance="outline">
                          <input matInput placeholder="Je recherche ma convention..." aria-label="Operation"
                                 [matAutocomplete]="auto" [formControl]="operation_form">
                          <mat-icon matSuffix>search</mat-icon>
                          <mat-autocomplete #auto="matAutocomplete">
                            <mat-option *ngFor="let operation of operations | async" [value]="operation.numero_operation" (onSelectionChange)="onSelection(operation)">
                              <span>{{(operation.numero_operation?operation.numero_operation:'Opération non renseignée')}} (UB:{{operation.ub}}/CR:{{operation.cr}}/SCR:{{operation.scr}})</span>
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>

                      <mat-card fxLayout="column" style="margin-left: 0;">
                        <mat-card-header>
                          <mat-card-title>Rechercher la convention à l'aide des critères ci-dessous</mat-card-title>
                        </mat-card-header>
                        <mat-card-content>

                          <div>
                            <mat-form-field fxFlex="50">
                              <mat-select formControlName="ub"
                                          placeholder="Choisir UB" [(value)]="dossier.ub" (selectionChange)="getCrs(annee,$event)">
                                <mat-option *ngFor="let ub of ubs" [value]="ub.ub">
                                  {{ub.ub}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>

                          </div>

                          <div>
                            <mat-form-field fxFlex="50">
                              <mat-select formControlName="cr"
                                          placeholder="Choisir CR" [(value)]="dossier.cr" (selectionChange)="getSousCrs(annee,$event)">
                                <mat-option *ngFor="let cr of crs" [value]="cr" >
                                  {{cr.cr}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>

                          <div>
                            <mat-form-field fxFlex="50">
                              <mat-select formControlName="scr"
                                          placeholder="S/CR" [(value)]="dossier.scr" (selectionChange)="getOperation(annee,$event)">
                                <mat-option *ngFor="let scr of scrs" [value]="scr">
                                  {{(scr.scr?scr.scr:'scr non rensigné')}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                          <div>
                            <mat-form-field fxFlex="50">
                              <mat-select formControlName="convention"
                                          placeholder="Numéro d'opération" [(value)]="dossier.convention_obj" (selectionChange)="onSelection($event.source.value)">
                                <mat-option *ngFor="let convention of conventions" [value]="convention">
                                  {{(convention.numero_operation?convention.numero_operation:'Numéro d\'opération vide')}}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  </mat-expansion-panel>
                </div>

                <ng-container *ngIf="convention_obj_temp">
                  <mat-card fxLayout="column" style="margin-left: 0;">
                    <mat-card-header>
                      <mat-card-subtitle>Convention/Ligne budgétaire </mat-card-subtitle>
                      <i class="material-icons" matTooltip="Enlever cette convention / opérationn" (click)="resetSelection()">delete_outline</i>
                    </mat-card-header>

                    <mat-card-content>
                      <p><span class="ttl">Opération: </span>{{(convention_obj_temp.numero_operation?convention_obj_temp.numero_operation:'Numéro d\'opération non renseigné')}}</p>
                      <p><span class="ttl">UB: </span>{{convention_obj_temp.ub}}</p>
                      <p><span class="ttl">CR: </span>{{convention_obj_temp.cr}}</p>
                      <p><span class="ttl">S/CR: </span>{{convention_obj_temp.scr}}</p>
                      <p><span class="ttl">Libelllé: </span>{{convention_obj_temp.libele_operation}}</p>
                      <p><span class="ttl">Descriptif: </span>{{convention_obj_temp.description_operation}}</p>
                    </mat-card-content>
                  </mat-card>
                </ng-container>

                <!-- LOLF -->

                <div [hidden]="dossier.code_lolf">
                  <br/>
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>Lolfs </mat-panel-title>
                      <mat-panel-description>Recherche un code LOLF ou choisir dans la liste déroulante</mat-panel-description>
                    </mat-expansion-panel-header>

                    <div>
                      <mat-form-field fxFlex="50" appearance="outline">
                        <input matInput placeholder="Recherche d'un lolf par son code ou libellé..." aria-label="Lolf"
                               [matAutocomplete]="auto_lolf" [formControl]="lolf_form">
                        <mat-icon matSuffix>search</mat-icon>
                        <mat-autocomplete #auto_lolf="matAutocomplete">
                          <mat-option *ngFor="let lolf of lolf_search | async"
                                      [value]="lolf.lolf_code"
                                      (onSelectionChange)="onSelectionLolf(lolf)">
                            <span>{{lolf.lolf_code}} {{lolf.lolf_abreviation}} ({{lolf.lolf_libelle}})</span>
                          </mat-option>
                        </mat-autocomplete>
                      </mat-form-field>
                    </div>

                    <mat-card fxLayout="column" style="margin-left: 0;">
                      <mat-form-field fxFlex="30">
                        <mat-select formControlName="code_lolf"
                                    placeholder="Lolf"
                                    (selectionChange)="onSelectionLolfSelect($event)">
                          <mat-option *ngFor="let lolf of lolfs" [value]="lolf">
                            {{lolf.lolf_code}} {{lolf.lolf_abreviation}} ({{lolf.lolf_libelle}})
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                      <!--<common-tree [content]="lolfs"-->
                      <!--[buttonChoice]="true"-->
                      <!--[labelButton]="'Choisir ce LOLF'"-->
                      <!--(getChildrens)="getLolfChildrens($event)"-->
                      <!--(sendContent)="setLolf($event)"-->
                      <!--[childrens]="(lolfs_childrens?lolfs_childrens:'')"></common-tree>-->
                    </mat-card>
                  </mat-expansion-panel>
                </div>

                <ng-container *ngIf="dossier.code_lolf">
                  <mat-card fxLayout="column" style="margin-left: 0;">
                    <mat-card-header>
                      <mat-card-subtitle>Lolf </mat-card-subtitle>
                      <i class="material-icons" matTooltip="Enlever ce Lolf" (click)="resetLolfSelection()">delete_outline</i>
                    </mat-card-header>

                    <mat-card-content>
                      <p><span class="ttl">Code Lolf: </span>{{dossier?.code_lolf_obj.lolf_code}}</p>
                      <p><span class="ttl">Libéllé: </span>{{dossier?.code_lolf_obj.lolf_abreviation}}</p>
                    </mat-card-content>
                  </mat-card>
                </ng-container>

                <!-- Code analytique -->

                <div *ngIf="! dossier.code_analytique">
                  <br/>
                  <mat-expansion-panel [expanded]="false">
                    <mat-expansion-panel-header>
                      <mat-panel-title>Codes analytiques </mat-panel-title>
                      <mat-panel-description>Double cliquer sur le code analytique désiré pour le sélectionner ou le bouton "Choisir" une fois un code analytique sélectionné</mat-panel-description>
                    </mat-expansion-panel-header>

                    <div class="code_analytique_recherche">
                      <div>
                        <mat-form-field fxFlex="50" appearance="outline">
                          <input matInput placeholder="Recherche d'un code analytique ..." aria-label="Code_analytique"
                                 [matAutocomplete]="auto_code_analytique" [formControl]="code_analytique_form">
                          <mat-icon matSuffix>search</mat-icon>
                          <mat-autocomplete #auto_code_analytique="matAutocomplete">
                            <mat-option *ngFor="let code_analytique of codes_analytiques_search | async" [value]="code_analytique.can_libelle" (onSelectionChange)="onSelectionCodeAnalytique(code_analytique)">
                              <span>{{code_analytique.can_libelle}} ({{code_analytique.can_code}})</span>
                            </mat-option>
                          </mat-autocomplete>
                        </mat-form-field>
                      </div>

                      <mat-card fxLayout="column" style="margin-left: 0;">
                        <p8-tree-lazy #treecodes *ngIf="codes_analytiquesSvc"
                                      (onSelect)="setCA($event)"
                                      [fieldsDisplay]="['label', 'code']"
                                      [svcLoad]="codes_analytiquesSvc"
                                      [fctLoadParents]="codes_analytiquesSvc.getBase"
                                      [fctLoadChildren]="codes_analytiquesSvc.getByParent"
                                      [mapModelFunction]="mapToCodesAnalytiquesTreeModel"
                                      [labelButton]="'Choisir ce code analytique'"
                                      [buttonChoice]="true"></p8-tree-lazy>

                      </mat-card>
                    </div>
                  </mat-expansion-panel>
                </div>

                <ng-container *ngIf="dossier.code_analytique">
                  <mat-card fxLayout="column" style="margin-left: 0;">
                    <mat-card-header>
                      <mat-card-subtitle>Code Analytique </mat-card-subtitle>
                      <i class="material-icons" matTooltip="Enlever ce code analytique" (click)="resetCASelection()">delete_outline</i>
                    </mat-card-header>

                    <mat-card-content>
                      <p><span class="ttl">Code: </span>{{dossier?.code_analytique_obj.can_code}}</p>
                      <p><span class="ttl">Libéllé: </span>{{dossier?.code_analytique_obj.can_libelle}}</p>
                    </mat-card-content>
                  </mat-card>
                </ng-container>

                <br/>
                <div fxLayoutAlign="end center">
                  <button mat-stroked-button color="accent" (click)="nextAffectation()" [disabled]="!posteFormGroup?.valid">Suivant</button>
                </div>
              </form>
            </mat-step>

            <!-- Affectation : direction ou composante, service ou département, labo, localisation -->

            <mat-step [stepControl]="affectationFormGroup" *ngIf="hasTypeDemande()">
              <form [formGroup]="affectationFormGroup">
                <ng-template matStepLabel><span class="mandatory-field">*</span> Affectation</ng-template>
                <div>
                  <mat-card fxFlex="70" fxFlex.lt-md="100">
                    <mat-card-actions align="end">
                      <button *ngIf="hasDirectionComposanteValue()"
                              (click)="onDeleteSDConfirm($event)"
                              mat-icon-button
                              matTooltip="Enlever la sélection de l'affectation">
                        <i class="material-icons">delete_outline</i>
                      </button>

                    </mat-card-actions>

                    <mat-card-content>
                      <div>
                        <div fxLayoutAlign="end center">
                          <button mat-stroked-button
                                  matTooltip="Chercher une direction ou composante"
                                  [color]="'warn'"
                                  (click)="openSearchEntiteArbo()">
                            <mat-icon color="warn" matSuffix>search</mat-icon> Chercher une direction ou composante
                          </button>
                        </div>
                        <div>
                          <span class="mandatory-field">*</span>
                          <mat-form-field fxFlex="100" fxFlex.lt-md="100">
                            <input formControlName="dir_cmp_label" type="text" matInput
                                   fxFlex="1 1 auto"
                                   placeholder="Direction ou Composante"
                                   name="departement">
                          </mat-form-field>
                        </div>
                      </div>

                      <div>
                        <div fxLayoutAlign="end center">
                          <button *ngIf="hasDirectionComposanteValue()"
                                  mat-stroked-button
                                  matTooltip="Chercher un service ou département ou labo"
                                  [color]="'warn'"
                                  (click)="openSearchEntiteArbo('svcdep')">
                            <mat-icon color="warn" matSuffix>search</mat-icon> Chercher un service ou département ou labo
                          </button>
                        </div>
                        <div>
                          <mat-form-field fxFlex="80" fxFlex.lt-md="100">
                            <input formControlName="svc_dep_label" type="text" matInput
                                   fxFlex="1 1 auto"
                                   placeholder="Service ou département ou labo"
                                   name="departement">
                          </mat-form-field>
                        </div>
                      </div>

                    </mat-card-content>
                  </mat-card>
                </div>

                <div>
                  <mat-form-field fxFlex="50">
                    <input [UpperCaseFirstLetter]="true"
                           formControlName="localisation"
                           matInput
                           placeholder="Localisation / Lieux de travail">
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="end center">
                  <button mat-stroked-button color="accent" (click)="nextPeriode()" [disabled]="!posteFormGroup?.valid">Suivant</button>
                </div>
              </form>
            </mat-step>

            <!-- Période de recrutement, quotité ou vacation selon le type de population -->

            <mat-step [stepControl]="periodeFormGroup" *ngIf="hasTypeDemande()">
              <form [formGroup]="periodeFormGroup">
                <ng-template matStepLabel><span class="mandatory-field">*</span> Période de recrutement demandée</ng-template>
                <div>
                  <span class="mandatory-field">*&nbsp;</span>
                  <mat-form-field fxFlex="30">
                    <mat-select formControlName="remuneration"
                                placeholder="Rémunération" [(value)]="dossier.remuneration">
                      <mat-option *ngFor="let remuneration of remunerations" [value]="remuneration.id">
                        {{remuneration.label}}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>

                <div fxLayoutGap="10px">
                  <span class="mandatory-field">*</span>
                  <mat-form-field fxFlex="15" fxFlex.lt-md="30" fxFlex.xs="35">
                    <input matInput formControlName="date_debut"
                           [min]="minDateDebut"
                           (dateChange)="onDateSelected($event, 'debut')"
                           [matDatepickerFilter]="dateSvc.filterWE"
                           [matDatepicker]="date_debut" placeholder="Du :">
                    <mat-datepicker-toggle matSuffix [for]="date_debut"></mat-datepicker-toggle>
                    <mat-datepicker #date_debut></mat-datepicker>
                  </mat-form-field>
                  <span class="mandatory-field">*</span>
                  <mat-form-field fxFlex="15" fxFlex.lt-md="30" fxFlex.xs="35">
                    <input matInput formControlName="date_fin"
                           [min]="minDate"
                           (dateChange)="onDateSelected($event)"
                           [matDatepickerFilter]="dateSvc.filterWE"
                           [matDatepicker]="date_fin" placeholder="Au :">
                    <mat-datepicker-toggle matSuffix [for]="date_fin"></mat-datepicker-toggle>
                    <mat-datepicker #date_fin></mat-datepicker>
                  </mat-form-field>

                  <mat-form-field fxFlex="15" fxFlex.lt-md="10" fxFlex.xs="15"
                                  fxFlexAlign="center">
                    <input matInput formControlName="duree" type="number" style="text-align: center"
                           matTooltip="Durée totale du recrutement en jours"
                           placeholder="Durée totale du recrutement en jours">
                  </mat-form-field>
                </div>

                <!-- quotité ou indicaire -->
                <div fxLayout="row" fxLayoutGap="10px">
                  <span class="mandatory-field">*&nbsp;</span>
                  <mat-form-field fxFlex="12" fxFlex.lt-sm="30"
                                  *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.indiciaire">
                    <input formControlName="quotite"
                           matInput
                           type="number"
                           matTooltip="% Quotité"
                           placeholder="% Quotité">
                    <div class="invalid-field" *ngIf="periodeFormGroup.get('quotite').touched">
                      <div *ngIf="periodeFormGroup.get('quotite').value <= 0">
                        doit être supérieur à 0
                      </div>
                    </div>
                  </mat-form-field>

                  <mat-form-field fxFlex="12" fxFlex.lt-sm="30"
                                  *ngIf="dossier.remuneration && dossier.remuneration === remunerationEnum.horaire">
                    <input formControlName="vacation_horaires"
                           matInput
                           type="number"
                           matTooltip="Vacation horaires"
                           placeholder="Vacation horaires">
                    <div class="invalid-field" *ngIf="periodeFormGroup.get('vacation_horaires').touched">
                      <div *ngIf="periodeFormGroup.get('vacation_horaires').value <= 0">
                        doit être supérieur à 0
                      </div>
                    </div>
                  </mat-form-field>
                </div>

                <div fxLayoutAlign="end center">
                  <button mat-stroked-button color="accent" (click)="nextFiles()">Suivant</button>
                </div>
              </form>
            </mat-step>

            <!-- PJs -->

            <mat-step [stepControl]="filesFormGroup" *ngIf="hasTypeDemande()">
              <form [formGroup]="filesFormGroup">
                <ng-template matStepLabel><span *ngIf="dossier?.type_demande === populationEnum.biatoss" class="mandatory-field">*</span> Pièces à joindre</ng-template>
                <div fxFlex="100" fxLayout="column">
                  <mat-expansion-panel [expanded]="false" style="background-color: #f5cc94">
                    <mat-expansion-panel-header>
                      <strong>Cliquer pour afficher/masquer le téléchargement des modèles de pièces jointes</strong>
                    </mat-expansion-panel-header>
                    <mat-panel-description>
                      <app-model-pj-view fxFlex="100"></app-model-pj-view>
                    </mat-panel-description>
                  </mat-expansion-panel>
                  <div style="padding-top: 10px;">Documents acceptés : pdf, odt, doc, docx, png</div>
                  <mat-card>
                    <mat-card-title>Fiches de poste et financière</mat-card-title>
                    <mat-card-content fxLayout="column">
                      <!-- fiche poste -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.poste].attachedFile"
                                      [typeFile]="typeFileEnum.poste"
                                      [titleFile]="getFileTitle(typeFileEnum.poste)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.poste)"
                                      [displayModelFiles]="true"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                      <!-- fiche financière -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.financiere].attachedFile"
                                      [typeFile]="typeFileEnum.financiere"
                                      [titleFile]="getFileTitle(typeFileEnum.financiere)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.financiere)"
                                      [displayModelFiles]="true"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                      <!-- autre pj -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.autre].attachedFile"
                                      [typeFile]="typeFileEnum.autre"
                                      [titleFile]="getFileTitle(typeFileEnum.autre)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.autre)"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>


                    </mat-card-content>
                  </mat-card>

                  <!-- autres pièces pi, cvitale, rib, dombank, casier -->
                  <mat-card>
                    <mat-card-title>Autres pièces justificatives</mat-card-title>
                    <mat-card-content>
                      <!-- CV -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.cv].attachedFile"
                                      [typeFile]="typeFileEnum.cv"
                                      [titleFile]="getFileTitle(typeFileEnum.cv)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.cv)"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                      <!-- pièce identité -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.pi].attachedFile"
                                      [typeFile]="typeFileEnum.pi"
                                      [titleFile]="getFileTitle(typeFileEnum.pi)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.pi)"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                      <!-- RIB -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.rib].attachedFile"
                                      [typeFile]="typeFileEnum.rib"
                                      [titleFile]="getFileTitle(typeFileEnum.rib)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.rib)"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                      <!-- carte vitale -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.cvitale].attachedFile"
                                      [typeFile]="typeFileEnum.cvitale"
                                      [titleFile]="getFileTitle(typeFileEnum.cvitale)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.cvitale)"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                      <!-- domiciliation bancaire -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.dombank].attachedFile"
                                      [typeFile]="typeFileEnum.dombank"
                                      [titleFile]="getFileTitle(typeFileEnum.dombank)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.dombank)"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                      <!-- casier judiciaire -->
                      <app-pj-dossier *ngIf="dossier"
                                      [dossier]="dossier"
                                      [attached_file]="piecesJointes[typeFileEnum.casier].attachedFile"
                                      [typeFile]="typeFileEnum.casier"
                                      [titleFile]="getFileTitle(typeFileEnum.casier)"
                                      [placeHolder]="getFilePlaceholder(typeFileEnum.casier)"
                                      (onFinished)="handleFilesUploaded([$event])"
                                      (onDeleted)="onDeletedFile($event)"></app-pj-dossier>

                    </mat-card-content>
                  </mat-card>
                </div>
              </form>
            </mat-step>

          </mat-vertical-stepper>
        </div>
      </mat-card-content>
    </mat-card>

    <p8-layout-settings-footer [flexLayoutAlign]="'end'">
      <span class="mat-body-2">{{progressComplete >= 100 ? 100 : progressComplete}} % de la saisie de la demande
        <mat-progress-bar mode="determinate" [value]="progressComplete" [color]="progressComplete >= 100 ? 'accent' : 'primary'"></mat-progress-bar>
        <mat-progress-bar mode="determinate" [value]="progressComplete" [color]="progressComplete >= 100 ? 'accent' : 'primary'"></mat-progress-bar>
      </span>

      <span style="border-left: 1px solid #9a9a9a; height: 36px; margin-right: 24px;"></span>

      <button *ngIf="previousUrl && retourAuthorized" mat-raised-button type="button" (click)="golist()"
              color="primary" matTooltip="Retour liste">Retour liste</button>

      <button mat-raised-button type="button" (click)="save()"
              [disabled]="dossier.type_demande === null"
              matTooltip="Sauvegarder cette demande pour la reprendre plus tard"
      >Sauvegarder cette demande</button>

      <span style="border-left: 1px solid #9a9a9a; height: 36px; margin-right: 24px;"></span>

      <app-button-transitions *ngIf="dossier && dossier.id > 0 && transitions.length > 0"
                              [state]="dossier?.state"
                              [dossier]="dossier"
                              [hasINMRecrutement]="(dossier?.remuneration === remunerationEnum.indiciaire && dossier?.motivation_obj?.inm_mandatory)"
                              [disabled]="! isEtapeRoleValide(dossier)"
                              [disabledReason]="disabledReason"
                              [transitions]="transitions"
                              (goTransition)="saveAndNextStep($event)">

      </app-button-transitions>
    </p8-layout-settings-footer>
  </p8-layout-settings-page>
</mat-drawer-container>
</div>
